import React from "react";
import {
  Breadcrumb,
  Button,
  Container,
  Header,
  Form,
  Grid,
  Image,
  Menu,
  Segment,
  Modal,
  Icon,
  Input,
  Loader,
  Message
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import SimpleList from "../lists/SimpleList";
import update from "immutability-helper";
import ExtendedComponent from "./ExtendedComponent";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import SubNavigationBar from "../navigation/SubNavigationBar";
import moment from "moment";
import numeral from "numeral";

var wrapWithProps = (func, ...props) => {
  return () => {
    func(...props);
  };
};

var valuePath = (object, defaultValue) => (...path) => {
  if (!object) {
    return defaultValue || null;
  }
  let response = object;
  for (var i = 0; i < path.length; i++) {
    let temp = response[path[i]];
    if (!temp) {
      i = path.length;
      response = defaultValue || null;
      return;
    }
    response = temp;
  }
  return response;
};

const VALUE_RANGES = {
  MIN: "99",
  MAX: "21000"
};

const INITIAL_STATE = {
  amount: VALUE_RANGES.MIN,
  showModal: false,
  response: null,
  error: null,
  loading: false,
  saldo: {
    loading: false,
    data: "0",
    error: null
  }
};

class AddFundsViews extends ExtendedComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE
    };

    this.LocalTransactionService = props.services.feathers.service(
      "api/localtransactions"
    );
    this.SaldoService = props.services.feathers.service("api/saldo");
    this.TransactionService = props.services.feathers.service(
      "api/transactions"
    );
  }

  getSaldo = () => {
    let { authentication } = this.props;

    this.setState(
      update(this.state, {
        saldo: {
          $merge: {
            loading: true,
            data: "Cargando..."
          }
        }
      })
    );

    this.SaldoService.get(authentication.user.SocioId)
      .then(response => {
        console.log(response);
        this.setState(
          update(this.state, {
            saldo: {
              $merge: {
                loading: false,
                data: numeral(response.monto).format("$0,0.00")
              }
            }
          })
        );
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            saldo: {
              $merge: {
                loading: false,
                error
              }
            }
          })
        );
      });
  };

  _fieldSet = (fieldName, map, validate) => {
    return (event, field) => {
      let value = !!map ? map(field.value) : field.value;
      if (!!validate && !validate(value)) {
        return;
      }
      this.set(fieldName || field.name, value).then(state => {
        console.log(state);
      });
    };
  };

  createTransaction = amount => {
    this.setAll({
      loading: true,
      showModal: false,
      response: null,
      error: null
    })
      .then(_ => this.LocalTransactionService.create({ amount }))
      .then(this.log("response"))
      .then(response =>
        this.setAll({ loading: false, showModal: true, response, error: null })
      );
  };

  componentDidMount() {
    this.getSaldo();
  }

  static mapDispatchToProps(dispatch) {
    return {
      dispatch,
      navigate: path => dispatch(push(path))
    };
  }

  static mapStateToProps(state) {
    return {
      authentication: state.authentication.toJS()
    };
  }

  render() {
    const { t, authentication } = this.props;
    const { amount, loading, showModal, response, saldo } = this.state;
    const userRoles = authentication && authentication.user && authentication.user.roles
      ? authentication.user.roles
      : [];

    const validAmount = amount => {
      return (
        (!isNaN(amount) && isFinite(amount) && amount >= 0) || amount == ""
      );
    };

    const greaterThan = (amount, minimum) => {
      return validAmount(amount) && amount > minimum;
    };

    const mapToNumber = value => {
      return value === "" ? "" : parseInt(value, 10);
    };

    return (
      <Container>
        <SubNavigationBar
          activeLink="saldo"
          roles={userRoles}
        />

        <Segment vertical secondary style={{ padding: 4 }}>
          <Breadcrumb>
            <Breadcrumb.Section as={Link} link to={"/dashboard"}>
              Inicio
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section as={Link} link to={"/balance"}>
              Balance
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section active>Agregar Fondos</Breadcrumb.Section>
          </Breadcrumb>
        </Segment>

        <Segment vertical>
          <Header as="h3">
            <Header.Content>
              AGREGAR FONDOS
              <Header.Subheader>Agregar fondos a mi cuenta</Header.Subheader>
            </Header.Content>
          </Header>
        </Segment>

        <Segment vertical>
          <Grid columns={2} stackable>
            <Grid.Column>
              <Header
                attached="top"
                as="h4"
                inverted
                style={{ backgroundColor: "#2185D0" }}>
                <Header.Content>
                  INGRESAR MONTO
                  <Header.Subheader>
                    Agregar fondos a través de MercadoPago
                  </Header.Subheader>
                </Header.Content>
              </Header>
              <Segment attached="bottom" clearing loading={loading}>
                <Image
                  floated="right"
                  src={require("../../assets/img/desktop-logo-mercadopago.png")}
                />
                {/*Pagando con tarjeta terminada en <Link to="/">0124</Link>*/}
                <Input
                  style={{ width: "100%" }}
                  label="$"
                  value={amount}
                  error={
                    !greaterThan(amount, VALUE_RANGES.MIN) ||
                    greaterThan(amount, VALUE_RANGES.MAX)
                  }
                  name="amount"
                  type="number"
                  onChange={this._fieldSet("amount", mapToNumber, validAmount)}
                />
                <Button
                  fluid
                  style={{ marginTop: 10 }}
                  content="Enviar"
                  icon="send"
                  onClick={wrapWithProps(this.createTransaction, amount)}
                  floated="right"
                  primary
                  disabled={
                    !greaterThan(amount, VALUE_RANGES.MIN) ||
                    greaterThan(amount, VALUE_RANGES.MAX)
                  }
                />
                <Message
                  hidden={
                    greaterThan(amount, VALUE_RANGES.MIN) &&
                    !greaterThan(amount, VALUE_RANGES.MAX)
                  }
                  negative
                  content={`Puedes cargar entre ${VALUE_RANGES.MIN} y ${
                    VALUE_RANGES.MAX
                  } pesos a tu cuenta`}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column>
              <SimpleList
                header="Mis Saldo"
                subheader="Transacciones"
                service={this.TransactionService}
                findParams={{
                  query: { $limit: 20, SocioId: authentication.user.SocioId }
                }}
                mappingFunc={transaction => ({
                  header: transaction.concepto,
                  description: moment(transaction.fecha)
                    .parseZone()
                    .format("DD/MM/YYYY HH:mm"),
                  icon: transaction.monto > 0 ? "circle add" : "circle minus",
                  iconColor: transaction.monto > 0 ? "green" : "red",
                  floatedContent: numeral(transaction.monto).format("$0,0.00"),
                  floatedContentColor: transaction.monto > 0 ? "green" : "red"
                })}
                statisticValue={saldo.data}
                statisticLabel="Balance"
                expandLink="/balance"
              />
            </Grid.Column>
          </Grid>
        </Segment>
        <Modal open={!!showModal} basic size="large">
          <Header
            icon="money"
            content={`Estás por cargar $${amount} a tu cuenta`}
          />
          <Modal.Content>
            <p>¿Quieres continuar con esta tarea?</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="red"
              inverted
              onClick={wrapWithProps(this.setAll, {
                showModal: false,
                response: null,
                amount: VALUE_RANGES.MIN
              })}>
              <Icon name="remove" /> No
            </Button>
            <Button
              color="green"
              inverted
              as="a"
              href={valuePath(response, "")("mercadopago", "init_point")}>
              <Icon name="checkmark" /> Cargar ${amount}
            </Button>
          </Modal.Actions>
        </Modal>
      </Container>
    );
  }
}

const i18nEnhancement = translate("translations")(AddFundsViews);

export default connect(
  AddFundsViews.mapStateToProps,
  AddFundsViews.mapDispatchToProps
)(i18nEnhancement);



// WEBPACK FOOTER //
// ./src/components/views/AddFundsView.jsx